<template>
    <div class="progress" v-bind="$attrs">
        <div 
            class="progress-bar" 
            :class="[!value ? 'empty' : '', barClasses]"
            role="progressbar" 
            :style="{ width: `${value}%` }" 
            :aria-valuenow="value" 
            aria-valuemin="0" 
            :aria-valuemax="maxValue"
        >
            <slot />
        </div>
    </div>
</template>

<script>
export default {
    name: "LineProgress",

    props: {
        color: {
            type: String,
            default: "",
        },
        barClasses: {
            type: String,
            default: "",
        },
        value: {
            type: Number,
            default: 0,
        },
        maxValue: {
            type: Number,
            default: 100,
        },
        size: { 
            type: String, 
            default: "md",
            validator: (value) => {
                return ["xs", "sm", "md", "lg"].includes(value);
            },
        },
    },
};
</script>

<style lang="scss" scoped>
    .progress {
        height: auto;
    }

    .progress-bar {
        padding: 3px 10px;
        height: 100%;  

        &.empty {
            background: transparent !important;
            background-color: transparent !important;
            color: #666;
        } 
    }
</style>